module.exports = __webpack_public_path__ + "static/mindset-88bfa0ba87cd3dc83154892139c48e27.jpg";